export interface IDiagnosis {
  diagnosisId: string,
  code: string,
  descriptionEnglish: string,
  descriptionArabic: string,
  diagnosisCodeTypeDesc: string,
  diagnosisCodeType: number
}

export const diagnosisConfig = {
  entityName: 'CONFIGURATION.DIAGNOSIS.TITLE',
  descriptionEnglish: 'FORM_FIELD.ENGLISH_DESCRIPTION',
  descriptionArabic: 'FORM_FIELD.ARABIC_DESCRIPTION',
  code: 'FORM_FIELD.CODE'
};

export enum DiagnosisCodeType {
  ICD10 = 1,
  Snomed = 2
}

export const DiagnosisCodeTypeLabel: { [key in DiagnosisCodeType]: string } = {
  [DiagnosisCodeType.ICD10]: "CONFIGURATION.DIAGNOSIS.ICD10",
  [DiagnosisCodeType.Snomed]: "CONFIGURATION.DIAGNOSIS.SNOMED",
};

export const DiagnosisCodeTypeValue: { [key in DiagnosisCodeType]: string } = {
  [DiagnosisCodeType.ICD10]: 'ICD10',
  [DiagnosisCodeType.Snomed]: 'Snomed',
};